/*
 *
 * Account actions
 *
 */

import {
  GET_OPTIONS_WATCHER,
  GET_OPTIONS_SUCCESS,
  GET_OPTIONS_FAILED,
  GET_INFO_COMPANY_WATCHER,
  GET_INFO_COMPANY_SUCCESS,
  GET_INFO_COMPANY_FAILED,
  PUT_INFO_COMPANY_WATCHER,
  PUT_INFO_COMPANY_SUCCESS,
  PUT_INFO_COMPANY_FAILED,
} from "./constants"

export function putInfoCompanyWatcher(payload) {
  return {
    type: PUT_INFO_COMPANY_WATCHER,
    payload,
  }
}

export function putInfoCompanySuccess(payload) {
  return {
    type: PUT_INFO_COMPANY_SUCCESS,
    payload,
  }
}

export function putInfoCompanyFailed(payload) {
  return {
    type: PUT_INFO_COMPANY_FAILED,
    payload,
  }
}

export function getInfoCompanyWatcher(payload) {
  return {
    type: GET_INFO_COMPANY_WATCHER,
    payload,
  }
}

export function getInfoCompanySuccess(payload) {
  return {
    type: GET_INFO_COMPANY_SUCCESS,
    payload,
  }
}

export function getInfoCompanyFailed(payload) {
  return {
    type: GET_INFO_COMPANY_FAILED,
    payload,
  }
}

export function getOptionsWatcher(payload) {
  return {
    type: GET_OPTIONS_WATCHER,
    payload,
  }
}

export function getOptionsSuccess(payload) {
  return {
    type: GET_OPTIONS_SUCCESS,
    payload,
  }
}

export function getOptionsFailed(payload) {
  return {
    type: GET_OPTIONS_FAILED,
    payload,
  }
}
